import React from 'react';
import styles from './styles.module.scss';
import cN from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { setSortType } from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';

const SearchResultSort = () => {
    const moduleName = 'sorters';
    const { SortType } = useSelector((state: RootState) => state.search);
    const dispatch = useDispatch();

    const handleSort = (typeValue: string) => dispatch(setSortType(typeValue));

    const sortTypes = [
        { text: '低價優先', value: 'price' },
        { text: '省時優先', value: 'time' },
    ];

    return (
        <div className={cN(moduleName, styles[`${moduleName}`])}>
            {sortTypes.map(({ text, value }) => (
                <div
                    key={value}
                    className={cN({ [styles.active]: SortType === value })}
                    onClick={() => handleSort(value)}
                >
                    {text}
                </div>
            ))}
        </div>
    );
};

export default SearchResultSort;
